import { labels } from "./labels";
import { translations } from "./pnl-search/search-translations";

export function getTranslatedLabel(languageCode){
    const label =  labels[languageCode];
    if(!label){
        return labels['nl_NL']; // if label not found return default nl_NL
    }
    return label;
}

export function getTranslatedSearchText(languageCode){
    const translation = translations[languageCode];
    if(!translation){
        return translations['nl_NL']; // if translation not found return default nl_NL
    }
    return translation;
}
